export default __webpack_public_path__ + "static/media/icon-delete.55a4f6bd.svg";